<template>
  <section
    v-show="lastSeenHasData"
    id="objects-last-seen"
    class="container"
  >
    <h2
      v-if="title"
      :class="titleClass + ' text-' + variant"
    >
      {{ title }}
    </h2>

    <div
      class="objects-last-seen"
      :class="variant"
    >
      <last-seen-object
        v-for="objectNumber in firstRowObjects"
        :key="'lastSeenObject_' + objectNumber"
        :last-seen-object-number="objectNumber"
      />
    </div>

    <div
      v-show="showAllRows"
      id="lsobjects-hidden"
      class="objects-last-seen"
      :class="furtherObjectsVariant"
    >
      <last-seen-object
        v-for="objectNumber in hiddenRowsObjects"
        :key="'lastSeenObject_' + objectNumber"
        :last-seen-object-number="objectNumber"
      />

      <div
        v-for="fillerNumber in filler"
        :key="fillerNumber"
        :class="'filler_'+fillerNumber"
      />
    </div>
    <div
      v-show="hiddenRowsObjects.length"
      :class="'section-more text-'+variant"
    >
      <button
        class="btn btn-default btn-collapse"
        type="button"
        data-ident="showAllRows"
        @click="showAllRows = !showAllRows"
      >
        <span v-show="!showAllRows">
          <i class="icon">
            <icon-chevron-down />
          </i>
          {{ $t('common:showMore') }} </span>
        <span v-show="showAllRows">
          <i class="icon">
            <icon-chevron-up />
          </i>
          {{ $t('common:showLess') }} </span>
      </button>
    </div>
    <pre v-if="debugOut">
      chunks: {{ chunks }}
      rowcount: {{ rowcount }}
      hiddenRowsObjects: {{ hiddenRowsObjects }}
      breakpoint: {{ breakpoint }}
    </pre>
  </section>
</template>

<script>
import DeviceHelper from 'mixins/DeviceHelper';
import { mapGetters, mapActions } from 'vuex';
import LastSeenObject from 'components/LastSeenObject.vue';

/* ICONS */
import IconChevronDown from 'ICON:IconChevronDown';
import IconChevronUp from 'ICON:IconChevronUp';

export default {
  name: 'LastSeenObjects',
  components: { LastSeenObject, IconChevronDown, IconChevronUp },
  mixins: [DeviceHelper],
  props: {
    limit: {
      type: [Number, String],
      default: 6,
    },
    exclude: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
    chunks: {
      type: Object,
      default: () => ({
        xs: 2,
        sm: 3,
        md: 4,
        lg: 6,
        xl: 6,
        other: 6,
      }),
    },
  },
  data() {
    return {
      debugOut: false,
      showAllRows: false,
    };
  },
  computed: {
    ...mapGetters([
      'getLastSeenObjects',
    ]),
    breakpoint() {
      return this.dh_breakpoint;
    },
    rowcount() {
      if (this.chunks[this.breakpoint]) { return this.chunks[this.breakpoint]; }
      return this.chunks.other;
    },
    firstRowObjects() {
      return this.lastSeenObjectNumbers.slice(0, this.rowcount);
    },
    furtherObjectsVariant() {
      if (this.firstRowObjects.length !== this.hiddenRowsObjects.length) { return 'left'; }
      return this.variant;
    },
    hiddenRowsObjects() {
      const lastSeenObjectsCount = Object.values(this.lastSeenObjectNumbers).length;
      // eslint-disable-next-line no-unused-vars
      const furtherRows = (lastSeenObjectsCount / this.rowcount) - 1;
      // return furtherRows;
      if (furtherRows > 0) {
        return this.lastSeenObjectNumbers.slice(this.rowcount, this.rowcount * 2);
      }
      return [];
    },
    filler() {
      if (this.hiddenRowsObjects.length > 0 && this.hiddenRowsObjects.length !== this.firstRowObjects.length) {
        return this.firstRowObjects.length - this.hiddenRowsObjects.length;
      }
      return 0;
    },
    lastSeenObjectNumbers() {
      const lastSeenObjectsStore = this.getLastSeenObjects;
      return lastSeenObjectsStore.filter(
        (objectNumber) => objectNumber !== this.exclude,
      );
    },
    lastSeenHasData() {
      let hasData = false;
      this.lastSeenObjectNumbers.forEach((objectNumber) => {
        if (this.$store.getters.getSearchObjectLastSeen(objectNumber)) {
          hasData = true;
        }
      });
      return hasData;
    },
  },
  mounted() {
    this.loadLastSeenObjects();
  },
  methods: {
    ...mapActions({ searchObjectsLastSeen: 'SEARCH_OBJECTS_LAST_SEEN' }),
    loadLastSeenObjects() {
      this.searchObjectsLastSeen({ objectNumbers: this.lastSeenObjectNumbers });
    },
  },
};
</script>
<style lang ="scss" src="@/scss/LastSeenObjects.scss" clientextend></style>
<style lang="scss" src="scss/LastSeenObjectsScoped.scss" scoped></style>
